import React from 'react';

import Loadable from 'react-loadable';
import {Route} from 'react-router-dom';


const LazyRulesContainer = Loadable({
  loader: () => import(
    /* webpackChunkName: "Rules" */
    './RulesContainer'
  ),
  loading: () => null
});

const RulesRoute = (
  <Route
    key="Rules"
    path="/rules/:ruleSlug/"
    component={LazyRulesContainer}
  />
);

export default RulesRoute;
